import { useSelector } from "react-redux";
import reduxModule from "./redux";

export const useAdvertisement = () => {
  const state = useSelector((state) => state.useAdvertisement);

  return {
    excel: (from, to, callback = null) => reduxModule.excel(from, to, callback),
    stats: (from, to, callback) => reduxModule.stats(from, to, callback),
    info: (ad_id, callback = null) => reduxModule.info(ad_id, callback),
    list: (callback = null) => reduxModule.list(callback),
    add: (data, callback = null) => reduxModule.add(data, callback),
    update: (data, callback = null) => reduxModule.update(data, callback),
    update2: (data, callback = null) => reduxModule.update2(data, callback),
    delete: (ad_id, callback = null) => reduxModule.delete(ad_id, callback),

    cleanExcelResponse: () => reduxModule.cleanExcelResponse(),

    state: state,

    excelResponse: state?.Excel,

    ad: state?.ad,
  };
};
